import { FC } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const ThemeTestToggle: FC = () => {
  const { t } = useTranslation()
  const isForcedThemeBrand = process.env.REACT_APP_BRAND === 'betbrothers'
  const isStage = window.location.hostname === 'stage.tipsterizer.app'
  if (!isForcedThemeBrand || !isStage) return null

  const onToggle = () => {
    const current = document.documentElement.getAttribute('data-theme')
    const next = current === 'light' ? 'dark' : 'light'
    const url = new URL(window.location.href)
    url.searchParams.set('themeOverride', next)
    window.location.href = url.toString()
  }

  return (
    <ToggleButton onClick={onToggle}>
      {t('themeTestToggle.toggleTheme')}
    </ToggleButton>
  )
}

const ToggleButton = styled.button`
  position: fixed;
  bottom: 90px;
  right: 16px;
  z-index: 9999;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  background: #000000;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
`

export default ThemeTestToggle
